module.exports = __webpack_public_path__ + "assets/img/Pioneer_Rochat_001.ff50ad18-ps.jpg";